import React from 'react';
import { CancelToken } from 'axios';

import GetNotifications from '@src/api/GetNotifications';
import { generateNotification } from '@src/factories';
import useAuthenticationTokens from '@src/hooks/useAuthenticationTokens';
import useList from '@src/hooks/useList';
import { Notification } from '@src/types';

const limit = 10;

const actives: { [key: string]: boolean } = {
  COMMENT: true,
  BROADCAST: true,
  COMMENT_REPLY: true,
  LIKE: true,
};

const useNotifications = () => {
  const {
    tokens: { accessToken },
  } = useAuthenticationTokens();

  const makeRequest = React.useCallback(
    async (
      newOffset: number,
      cancelToken: CancelToken
    ): Promise<Notification[]> => {
      const response = await GetNotifications(accessToken, newOffset, limit, {
        cancelToken,
      });
      return response.data.notifications
        .map((notification) => generateNotification(notification))
        .filter((notification) => actives?.[notification.type] ?? false);
    },
    [accessToken]
  );

  return useList(makeRequest, 'Get notifications cancelled');
};

export default useNotifications;
